// Hooks (@tanstack/react-query) imports
import { useMutation, useQueryClient } from "@tanstack/react-query";

// Configs imports
import api from "../../app/api";

// Custom types imports
import { InvoiceRegistration } from "./types";
import { ApiErrorResponse } from "apisauce";
import { fetchingModelDefaults } from "../tickets/types";

// Hooks & actions imports
import { useAppSelector } from "../../app/hook";

interface paramsType {
  invoice: InvoiceRegistration;
  notificationID: string | number;
}

export function useUpdateInvoiceMutation(
  onSuccessMutation?: (data: any, variables: paramsType) => void,
  onErrorMutation?: (err: ApiErrorResponse<any>, variables: paramsType) => void
) {
  const queryClient = useQueryClient();
  const currentUser = useAppSelector((state) => state.auth);

  async function updateInvoice(params: paramsType): Promise<any> {
    queryClient.invalidateQueries(["TicketsInfinite"]);
    const response = await api.put<any>(`invoices/invoices`, params.invoice);

    if (!response.ok) {
      throw response;
    }

    return response.data;
  }

  return useMutation({
    mutationFn: updateInvoice,
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries([
        "TicketsInfinite",
        ...Object.values({
          ...fetchingModelDefaults,
          storeID:
            !!currentUser.user?.companyID && currentUser.user?.companyID !== -1
              ? currentUser.user.companyID
              : 0,
        }),
      ]);
      queryClient.invalidateQueries(["Invoice", variables.invoice.id]);
      onSuccessMutation?.(data, variables);
    },
    onError: onErrorMutation,
  });
}
